<template>
  <div class="customerBox">
    <div class="main">
      <div class="nav">
        <span :class="navIndex == 0 ? 'active' : ''" @click="navSwitch(0)"
          >已绑定 <em>{{ util.showCount(bindingCount) }}</em></span
        >
        <span :class="navIndex == 1 ? 'active' : ''" @click="navSwitch(1)"
          >已解绑 <em>{{ util.showCount(unbundlingCount) }}</em></span
        >
      </div>
      <div class="searchContentBox">
        <Search
          :searchOpt="searchOpt"
          v-on:serchCallback="serchCallback"
        ></Search>
      </div>
      <div class="swiperContent">
        <swiper ref="mySwiper" :options="swiperOption" class="swiper-wrapper">
          <swiper-slide>
            <mescroll-vue
              ref="mescroll1"
              :down="mescrollDown1"
              :up="mescrollUp1"
              @init="mescrollInit1"
            >
              <ul v-if="bindingList.length > 0">
                <li
                  v-for="(item, index) in bindingList"
                  :key="index"
                  @click="getDetail(item)"
                >
                  <div class="img">
                    <img :src="item.headerimg" />
                  </div>
                  <div class="detail">
                    <div class="desc">
                      <p class="name">{{ item.nickname }}</p>
                    </div>
                    <div>
                      <p class="contribution">
                        <span> 贡献奖励</span
                        ><em
                          >¥ {{ util.toFixed(item.contributionmoney, 2) }}</em
                        >
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="notDataBox" v-else>
                <NotData className="dynamic" title="暂无已绑定用户"></NotData>
              </div>
            </mescroll-vue>
          </swiper-slide>
          <swiper-slide>
            <mescroll-vue
              ref="mescroll2"
              :down="mescrollDown2"
              :up="mescrollUp2"
              @init="mescrollInit2"
            >
              <ul v-if="unbundlingList.length > 0">
                <li
                  v-for="(item, index) in unbundlingList"
                  :key="index"
                  @click="getDetail(item)"
                >
                  <div class="img">
                    <img :src="item.headerimg" alt="" />
                  </div>
                  <div class="detail">
                    <div class="desc">
                      <p class="name">{{ item.nickname }}</p>
                      <p class="title">{{ item.comments }}</p>
                    </div>
                    <div>
                      <p class="contribution">
                        贡献奖励¥ {{ util.toFixed(item.contributionmoney,2) }}
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="notDataBox" v-else>
                <NotData className="dynamic" title="暂无已解绑用户"></NotData>
              </div>
            </mescroll-vue>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="toast" v-if="showToast">
      <div class="customerDetail">
        <div class="info">
          <img :src="info.headerimg" />
          <p>{{ info.nickname }}</p>
        </div>
        <div class="close" @click="hideToast()">
          <img src="@/assets/img/h5/close.png" />
        </div>
        <div class="contribution">
          <div>
            <p class="value">{{ util.toFixed(info.contributionmoney,2) }}</p>
            <p class="title">累计贡献奖励(元)</p>
          </div>
          <div>
            <p class="value">{{ util.toFixed(info.contributionorders,2) }}</p>
            <p class="title">订单数量(笔)</p>
          </div>
        </div>
        <ul class="detail">
          <li>
            <span class="label">绑定时间</span>
            <span class="content">{{
              util.changeTime({ time: info.bindtime, line: "text" })
            }}</span>
          </li>
          <li v-if="navIndex == 1">
            <span class="label">解绑时间</span>
            <span class="content">{{
             util.changeTime({ time: info.unbindtime, line: "text" })
            }}</span>
          </li>
          <li v-if="navIndex == 1">
            <span class="label">解绑原因</span>
            <span class="content">{{ info.comments }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Search from "@/components/search";
import MescrollVue from "mescroll.js/mescroll.vue";
import NotData from "@/components/notData";

export default {
  name: "customer",
  metaInfo() {
    return {
      title: "累计客户",
    };
  },
  data() {
    return {
      info: "",
      showToast: false,
      customerid: "",
      navIndex: 0,
      bindingCount: 0,
      bindingList: [],

      unbundlingCount: 0,
      unbundlingList: [],
      swiperOption: {
        noSwiping: true,
        autoHeight: true,
        onSlideChangeStart: function (swiper) {
          this.navSwitch(swiper.activeIndex);
        }.bind(this),
      },
      mescroll1: null, // mescroll实例对象
      mescrollDown1: {
        auto: false,
        callback: this.downCallback1,
      },
      mescrollUp1: {
        callback: this.upCallback1, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
        //以下是一些常用的配置,当然不写也可以的.
        htmlNodata: '<p class="upwarp-nodata">暂无更多数据</p>',
        page: {
          num: 0,
          size: 10,
        },
        noMoreSize: 5, //如果列表已无数据,可设置列表总数大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          // warpId: "xxid", //父布局的id (1.3.5版本支持传入dom元素)
          //icon: "./static/mescroll/mescroll-empty.png", //图标,默认null,支持网络图
          tip: "暂无相关数据~", //提示
        },
      },
      mescroll2: null, // mescroll实例对象
      mescrollDown2: {
        auto: false,
        callback: this.downCallback2,
      },
      mescrollUp2: {
        callback: this.upCallback2, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
        //以下是一些常用的配置,当然不写也可以的.
        htmlNodata: '<p class="upwarp-nodata">暂无更多数据</p>',
        page: {
          num: 0,
          size: 10,
        },
        noMoreSize: 5, //如果列表已无数据,可设置列表总数大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          // warpId: "xxid", //父布局的id (1.3.5版本支持传入dom元素)
          //icon: "./static/mescroll/mescroll-empty.png", //图标,默认null,支持网络图
          tip: "暂无相关数据~", //提示
        },
      },
      searchOpt: {
        tip: "请输入用户名称查找",
      },
      searchText: "",
    };
  },
  components: {
    Search,
    MescrollVue,
    NotData,
  },
  mounted() {},
  methods: {
    getDetail(item) {
      this.showToast = true;
      var obj = {
        custdistributionid: item.custdistributionid,
      };
      this.$post(
        "/iart-api-crm/api/crm/custdistribution/queryCustdistribution",
        obj
      ).then((res) => {
        if (res.code == 1) {
          this.info = res.data;
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },

    hideToast() {
      this.showToast = false;
    },
    serchCallback(data) {
      if (data.type == "search") {
        // if (data.searchText) {
        this.searchText = data.searchText;
        this.mescroll1.resetUpScroll();
        this.mescroll2.resetUpScroll();
        // }
      } else if (data.type == "cancel") {
        if (this.searchText) {
          this.searchText = "";
          this.mescroll1.resetUpScroll();
          this.mescroll2.resetUpScroll();
        }
      }
    },
    mescrollInit1(mescroll) {
      this.mescroll1 = mescroll;
    },
    mescrollInit2(mescroll) {
      this.mescroll2 = mescroll;
    },
    downCallback1() {
      this.mescroll1.resetUpScroll();
    },
    upCallback1(page, mescroll) {
      this.getListDataFromNet1(page.num, page.size, mescroll);
    },
    getListDataFromNet1(num, size, mescroll) {
      if (num == 1) {
        this.bindingList = [];
      }
      var obj = {
        diststate: "1001",
        pageNum: num,
        pageSize: size,
        nickname: this.searchText,
      };
      this.$post(
        "/iart-api-crm/api/crm/custdistribution/queryByCustdistributionList",
        obj
      ).then((res) => {
        if (res.code == 1) {
          var data = res.data && res.data.rows ? res.data.rows : [];
          this.bindingList = this.bindingList.concat(data);
          this.bindingCount = res.data.total;
          this.$nextTick(() => {
            mescroll.endSuccess(data.length);
          });
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    upCallback2(page, mescroll) {
      this.getListDataFromNet2(page.num, page.size, mescroll);
    },
    downCallback2() {
      this.mescroll2.resetUpScroll();
    },
    getListDataFromNet2(num, size, mescroll) {
      if (num == 1) {
        this.unbundlingList = [];
      }
      var obj = {
        diststate: "1003",
        pageNum: num,
        pageSize: size,
        nickname: this.searchText,
      };
      this.$post(
        "/iart-api-crm/api/crm/custdistribution/queryByCustdistributionList",
        obj
      ).then((res) => {
        if (res.code == 1) {
          var data = [];
          var data = res.data && res.data.rows ? res.data.rows : [];
          this.unbundlingList = this.unbundlingList.concat(data);
          this.unbundlingCount = res.data.total;
          this.$nextTick(() => {
            mescroll.endSuccess(data.length);
          });
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    navSwitch(index) {
      this.navIndex = index;
      this.$refs.mySwiper.swiper.slideTo(index, 200, false);
    },
  },
};
</script>

<style lang="scss" scoped>
.customerBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    .nav {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      border-bottom: 0.5px solid rgba(151, 151, 151, 0.2);
      span {
        padding: 10px 0;
        position: relative;
        font-size: 14px;
        line-height: 24px;
        color: #86878a;
      }
      span.active {
        color: #35363c;
        font-weight: 600;
      }
      span.active::before {
        content: " ";
        display: inline-block;
        width: 16px;
        height: 2px;
        background: #35363c;
        position: absolute;
        left: 50%;
        bottom: 0;
        margin-left: -8px;
      }
    }
    .searchContentBox {
      padding: 16px 16px;
      .searchBox {
        display: flex;
        flex-direction: row;
      }
    }
    .swiperContent {
      flex: 1;
      margin-top: 4px;
      .swiper-container {
        height: 100%;
      }
      /deep/ .swiper-wrapper {
        height: 100% !important;
      }
      /deep/ .swiper-slide {
        height: 100%;
      }
      ul {
        padding-left: 16px;
        li {
          display: flex;
          flex-direction: row;
          padding-top: 20px;
          .img {
            height: 60px;
            padding-bottom: 20px;
            img {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              object-fit: cover;
              vertical-align: middle;
            }
          }
          .detail {
            padding-bottom: 20px;
            padding-right: 16px;
            flex: 1;
            margin-left: 12px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            .desc {
              .name {
                font-size: 14px;
                line-height: 20px;
                color: #333333;
                font-weight: 600;
              }
              .title {
                margin-top: 2px;
                font-size: 11px;
                line-height: 16px;
                color: rgba(53, 54, 60, 0.4);
              }
            }
            div {
              margin-left: 12px;
              .contribution {
                font-size: 12px;
                line-height: 17px;
                color: #333333;
                em {
                  font-size: 16px;
                  font-weight: 600;
                  line-height: 21px;
                  margin-left: 4px;
                }
              }
              .tip {
                font-size: 12px;
                line-height: 17px;
                color: #999999;
                margin-top: 4px;
              }
            }
          }
        }
        li:not(:last-child) {
          .detail {
            border-bottom: 1px solid #ededed;
          }
        }
      }
    }
  }
  .toast {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 11;
    background: rgba(0, 0, 0, 0.5);
    .customerDetail {
      position: absolute;
      left: 0;
      // top: 0;
      right: 0;
      bottom: 0;
      background: #ffffff;
      border-radius: 12px 12px 0 0;
      padding: 0 16px 90px;
      text-align: center;
      .info {
        align-items: center;
        margin-top: -14px;
        img {
          width: 60px;
          height: 60px;
          border: 3px solid #ffffff;
          border-radius: 50%;
        }
        p {
          font-size: 16px;
          font-weight: bold;
          line-height: 22px;
          color: #35363c;
          margin-top: 16px;
        }
      }
      .close {
        width: 32px;
        height: 32px;
        position: absolute;
        top: 16px;
        right: 16px;
        img {
          width: 32px;
          height: 32px;
        }
      }
      .contribution {
        display: flex;
        flex-direction: row;
        margin-top: 16px;
        > div {
          flex: 1;
          text-align: center;
          position: relative;
          overflow: hidden;
          .value {
            font-size: 22px;
            line-height: 28px;
            color: #35363c;
            font-weight: bold;
          }
          .title {
            font-size: 12px;
            line-height: 17px;
            color: rgba(53, 54, 60, 0.7);
            margin-top: 4px;
          }
        }
      }
      .detail {
        margin-top: 12px;
        background: #fff;
        border-radius: 4px;
        li {
          padding: 20px 0;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          line-height: 20px;
          border-top: 1px solid #e0e0e0;
          .label {
            color: #35363c;
            font-size: 14px;
            line-height: 20px;
            font-weight: bold;
          }
          .content {
            color: #5d5e63;
            font-size: 14px;
            line-height: 20px;
            font-weight: 300;
          }
        }
      }
    }
  }
}
</style>